var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser31(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1684_23726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 25.8533 37.485 31.1194 33.4775 34.7772C29.9219 38.0212 25.1923 40 20 40C14.8077 40 10.0781 38.0212 6.52252 34.7772C2.51495 31.1194 0 25.8533 0 20C0 8.95477 8.95477 0 20 0C31.0452 0 40 8.95477 40 20Z",
    fill: "#E6ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 25.8533 37.485 31.1194 33.4775 34.7772C29.9219 38.0212 25.1923 40 20 40V0C31.0452 0 40 8.95477 40 20Z",
    fill: "#E6ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4775 34.6976V34.7773C29.9219 38.0213 25.1923 40.0001 20 40.0001C14.8077 40.0001 10.0781 38.0213 6.52252 34.7773V34.6976C6.52252 28.9039 10.1978 23.9515 15.34 22.0518C16.7923 21.514 18.3624 21.2205 20 21.2205C21.6376 21.2205 23.2077 21.514 24.6609 22.0518C29.8032 23.9524 33.4775 28.9039 33.4775 34.6976Z",
    fill: "#1E17B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4775 34.6976V34.7773C29.9219 38.0213 25.1923 40.0001 20 40.0001V21.2205C21.6376 21.2205 23.2077 21.514 24.6609 22.0518C29.8032 23.9524 33.4775 28.9039 33.4775 34.6976Z",
    fill: "#2820DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2663 15.2282C28.2663 19.786 24.5587 23.4948 20 23.4948C15.4422 23.4948 11.7337 19.786 11.7337 15.2282C11.7337 10.6704 15.4422 6.96191 20 6.96191C24.5587 6.96191 28.2663 10.6704 28.2663 15.2282Z",
    fill: "#2820DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2663 15.2282C28.2663 19.786 24.5587 23.4948 20 23.4948V6.96191C24.5587 6.96191 28.2663 10.6704 28.2663 15.2282Z",
    fill: "#1E17B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1684_23726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser31);
export default __webpack_public_path__ + "static/media/user (3) 1.d58b42b072335e792f12c063dafe37df.svg";
export { ForwardRef as ReactComponent };